import { render, staticRenderFns } from "./Titulos.vue?vue&type=template&id=40e860ec&scoped=true&"
import script from "./Titulos.vue?vue&type=script&lang=js&"
export * from "./Titulos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../bym/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e860ec",
  null
  
)

export default component.exports